'use client';

import { cn } from '@/lib/utils';
import Image from 'next/image';
import { forwardRef, useCallback } from 'react';

const breakpoints = {
  245: 'thumbnail',
  500: 'small',
  750: 'medium',
  1000: 'large',
  1400: 'xlarge'
};

const ResponsiveImage = forwardRef(function ({ alt = '', file, fallbackSrc, src: _, className, ...props }, ref) {
  const extraProps = {};

  const imageLoader = useCallback(
    ({ src, width, quality = 100 }) => {
      if (typeof file === 'string') return `${src}?w=${width}&q=${quality}`;
      const format = `${breakpoints[width]}`;
      const formats = file.formats;
      if (formats?.[format]) return `${formats[format].url}?w=${width}`;
      return `${src}?w=${width}`;
    },
    [file]
  );

  if (!file && fallbackSrc)
    return <Image src={fallbackSrc} alt={alt} {...props} ref={ref} className={cn('italic', className)} />;

  if (typeof file === 'string') extraProps['src'] = file;

  if (typeof file === 'object') {
    extraProps['src'] = file?.url;
    extraProps['width'] = file?.width;
    extraProps['height'] = file?.height;
  }

  if (props.fill) {
    extraProps['width'] = undefined;
    extraProps['height'] = undefined;
  }

  if (!file) extraProps.src = fallbackSrc;

  if (!file) return <div className={className} />;

  return (
    <Image
      sizes='100vw'
      {...props}
      alt={alt}
      ref={ref}
      {...extraProps}
      loader={imageLoader}
      className={cn('italic', className)}
    />
  );
});

ResponsiveImage.displayName = 'ResponsiveImage';

export default ResponsiveImage;
